module.exports = __webpack_public_path__ + "static/img/attack_english_dark.6304e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attack_english_dark.png
// module id = omVJ
// module chunks = 94